import flaggermany from "@assets/images/admin/flags/germany.svg";
import flagus from "@assets/images/admin/flags/us.svg";
/*import flagspain from "@assets/images/admin/flags/spain.svg";
import flagitaly from "@assets/images/admin/flags/italy.svg";
import flagrussia from "@assets/images/admin/flags/russia.svg";
import flagchina from "@assets/images/admin/flags/china.svg";
import flagfrench from "@assets/images/admin/flags/french.svg";
import flagarabic from "@assets/images/admin/flags/ae.svg";*/


const languages = {
  de: {
    label: "Deutsch",
    flag: flaggermany,
  },
  en: {
    label: "English",
    flag: flagus,
  },
  /*sp: {
    label: "Española",
    flag: flagspain,
  },
  it: {
    label: "Italiana",
    flag: flagitaly,
  },
  rs: {
    label: "русский",
    flag: flagrussia,
  },
  cn: {
    label: "中国人",
    flag: flagchina,
  },
  fr: {
    label: "français",
    flag: flagfrench,
  },
  ar: {
    label: "Arabic",
    flag: flagarabic,
  },*/
}

export default languages
